import Vue from 'vue'
import {
  LayoutPlugin,
  ImagePlugin,
  SpinnerPlugin,
  TooltipPlugin,
  PopoverPlugin,
  ModalPlugin
} from 'bootstrap-vue'
import Vue2BingMaps from 'rhg-bing-maps'
import * as VueGoogleMaps from 'vue2-google-maps'
import App from '@/App'
import store from '@/store'
import * as RhgVueCommon from 'rhg-vue-common'
import '@/infrastructure/Directives'
import '@/infrastructure/Filters'
import '@/infrastructure/Mixins'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-glide-js/dist/vue-glide.css'
import { isChina } from '@/infrastructure/Configuration'
import VueMaps from 'rhg-vue-maps'
import PortalVue from 'portal-vue'
import GmapCluster from 'vue2-google-maps/src/components/cluster'
import GmapCustomMarker from '@/components/discovery/map/GmapCustomMarker'
import { extend } from 'vee-validate'
import { email, required, max, regex } from 'vee-validate/dist/rules'
import { translate } from 'rhg-vue-common'

Vue.config.productionTip = false
Vue.prototype.trackingService = global.trackingService
Vue.prototype.trackingEvents = global.trackingEvents

if (global.RhgVueCommon) {
  // eslint-disable-next-line no-console
  console.log('using global.RhgVueCommon')
  Vue.use(global.RhgVueCommon)
} else {
  // eslint-disable-next-line no-console
  console.log('using RhgVueCommon')
  Vue.use(RhgVueCommon)
}

if (isChina) {
  Vue.use(VueMaps)
  Vue.use(Vue2BingMaps)
} else {
  Vue.use(VueGoogleMaps)
  Vue.component('GmapCluster', GmapCluster)
  Vue.component('GmapCustomMarker', GmapCustomMarker)
}

Vue.use(LayoutPlugin)
Vue.use(ImagePlugin)
Vue.use(TooltipPlugin)
Vue.use(SpinnerPlugin)
Vue.use(PortalVue)
Vue.use(PopoverPlugin)
Vue.use(ModalPlugin)

Vue.filter('toGoogleCoordinates', ({ latitude, longitude }) => ({
  lat: latitude,
  lng: longitude
}))

extend('required', {
  ...required,
  message: 'This field is required'
})
extend('email', {
  ...email,
  message: 'Email format incorrect'
})
extend('checked', {
  validate: value => ({
    required: true,
    valid: value === true
  })
})
extend('length', {
  validate: value => ({
    required: true,
    valid: (value || '') !== '' && value.length >= 8 && value.length <= 20
  })
})
extend('containsNumber', {
  validate: value => ({
    required: true,
    valid: (value || '') !== '' && /\d/.test(value)
  })
})
extend('containsUpperCase', {
  validate: value => ({
    required: true,
    valid: (value || '') !== '' && /[A-Z]/.test(value)
  })
})
extend('maximumValidateNumber', {
  params: ['target'],
  validate(value, { target }) {
    return value <= target
  }
})
extend('containsLowerCase', {
  validate: value => ({
    required: true,
    valid: (value || '') !== '' && /[a-z]/.test(value)
  })
})
extend('password', {
  params: ['target'],
  validate(value, { target }) {
    return value === target
  },
  message: 'Password confirmation does not match'
})
extend('max', {
  ...max,
  message: 'This field cannot be longer than {length} characters'
})
extend('regex', {
  ...regex,
  message: () => translate('chInvalidFormat')
})
extend('containsSpecialCharacter', {
  validate: value => ({
    required: true,
    valid: (value || '') !== '' && /[`!"@#$%^&'*()_+\-=\\|,./:;<>?~]/.test(value)
  })
})

// This conditional prevents vue from mounting in memory when it doesn't find the mounting point.
const mountPoint = document.querySelector('#search-map-destinations')

if (mountPoint) {
  window.searchMapDestinationsVue = new Vue({
    store,
    render: h => h(App)
  }).$mount('#search-map-destinations')
} else {
  window.trackingService.triggerAnalyticsEvent()
}
